import React, { useState, useEffect } from "react"
import { Switch, Route, useHistory, useLocation } from "react-router-dom"
import { useMediaQuery } from "react-responsive"

import { fbAuth } from "./services/Firebase"
import VoiceMsgProvider from "./contexts/VoiceMsgContext"
import FavoriteProvider from "./contexts/FavoriteContext"
import { ThemeContext } from "./contexts/ThemeContext"
import { SearchRecipeContext } from "./contexts/SearchRecipeContext"
import { ShowSearchContext } from "./contexts/ShowSearchContext"
import { GuideContext } from "./contexts/GuideContext"
import { UserContext } from "./contexts/UserContext"
import Home from "./pages/Home"
import Footer from "./components/Footer"
import Onboarding from "./pages/Onboarding"
import VoiceRecognition from "./components/VoiceRecognition"
import "./styles/App.css"
import RecipeGallery from "./pages/recipe/RecipeGallery"
import FavoritePage from "./pages/favorite/FavoritePage"

function App() {
    const history = useHistory()
    const location = useLocation()
    const isMobileDevice = useMediaQuery({ query: "(max-device-width: 650px)" })
    const [ isSignedIn, setIsSignedIn ] = useState( false )
    const [ voiceMessage, setVoiceMessage ] = useState( "" )
    const [ isGuest, setIsGuest ] = useState( false )
    const [ allRecipes, setAllRecipes ] = useState([])
    const [ showPage, setShowPage ] = useState( false )
    const [ globalTheme, setGlobalTheme ] = useState( "light" )
    const [ themeIcon, setThemeIcon ] = useState( "sun" )
    const [ showGuide, setShowGuide ] = useState( true )
    const [ notSupport, setNotSupport ] = useState( false )
    const [ user, setUser ] = useState( null )

    useEffect(() => {
        history.push( "/" )
        const unsubscribe = fbAuth.onAuthStateChanged(user => {
            user?.isAnonymous ? setIsGuest( true ) : setIsGuest( false )
            user ? setIsSignedIn(true) : setIsSignedIn(false)
            user && setUser( user )
            return () => unsubscribe()
        })

        if (localStorage) {
            setGlobalTheme( localStorage.getItem("theme") )
            setThemeIcon( localStorage.getItem("icon") )
        }
    }, [history])

    return (
        <UserContext.Provider value={user}>
            <VoiceMsgProvider message={voiceMessage}>
                <GuideContext.Provider value={{ showGuide, setShowGuide, notSupport, setNotSupport }}>
                    <ThemeContext.Provider value={{ globalTheme, themeIcon, setGlobalTheme, setThemeIcon }}>
                        <SearchRecipeContext.Provider value={{ allRecipes, setAllRecipes }}>
                            <ShowSearchContext.Provider value={{ showPage, setShowPage }}>
                                <FavoriteProvider isGuest={isGuest} >
                                    <div className="App">
                                        {
                                            isSignedIn 
                                                ?   <Switch>
                                                    <Route exact path="/" component={Home} />
                                                    <Route path="/recipe" component={Home} />
                                                    <Route path="/wine" component={Home} />
                                                    <Route path={`/search/${voiceMessage}`} component={RecipeGallery} />
                                                    <Route path="/search">
                                                        <RecipeGallery key={location.pathname}/>
                                                    </Route>
                                                    <Route path="/searchRecipe" component={RecipeGallery} />
                                                    <Route path="/favorite" component={FavoritePage} />
                                                </Switch>
                                                :   <Onboarding />
                                        }
                                        <VoiceRecognition setVoiceMessage={setVoiceMessage} />
                                        <Footer isMobileDevice={isMobileDevice} />
                                    </div>
                                </FavoriteProvider>
                            </ShowSearchContext.Provider>
                        </SearchRecipeContext.Provider>
                    </ThemeContext.Provider>
                </GuideContext.Provider>
            </VoiceMsgProvider>
        </UserContext.Provider>
    )
}

export default App